import { gql } from "@apollo/client";

export const GET_BOOKINGS_COUNT = gql`
  {
    bookingsCount
  }
`;